import { formatBytes, formatEta, formatPercent, formatSpeed, throughput } from '../format.js';
import { t } from '../i18n/index.js';
import { el } from './dom.js';

export type ProgressUpdate = Readonly<{
  doneBytes: number;
  totalBytes: number;
  startedAtMs: number;
  nowMs: number;
  /** Optional secondary line, e.g. bytes acknowledged by the other side. */
  detail?: string;
}>;

export type ProgressPanel = Readonly<{
  element: HTMLElement;
  update: (progress: ProgressUpdate) => void;
  setRoute: (text: string) => void;
  complete: (text: string) => void;
}>;

export const createProgressPanel = (title: string): ProgressPanel => {
  const heading = el('div', { className: 'progress__title', text: title });
  const percent = el('div', { className: 'progress__percent', text: '0%' });
  const fill = el('div', { className: 'progress__fill' });
  const track = el('div', { className: 'progress__track' }, [fill, el('div', { className: 'progress__comet' })]);
  const bytes = el('div', { className: 'progress__meta' });
  const speed = el('div', { className: 'progress__meta progress__meta--right' });
  const detail = el('div', { className: 'progress__detail' });
  const route = el('div', { className: 'progress__route', text: t('route.finding') });
  const element = el('section', { className: 'card progress' }, [
    el('div', { className: 'progress__head' }, [heading, percent]),
    track,
    el('div', { className: 'progress__row' }, [bytes, speed]),
    detail,
    route,
  ]);

  return {
    element,
    update: (progress) => {
      const ratio = progress.totalBytes === 0 ? 1 : progress.doneBytes / progress.totalBytes;
      fill.style.width = `${Math.min(100, ratio * 100)}%`;
      percent.textContent = formatPercent(progress.doneBytes, progress.totalBytes);
      bytes.textContent = t('progress.of', { done: formatBytes(progress.doneBytes), total: formatBytes(progress.totalBytes) });
      const rate = throughput(progress.doneBytes, progress.startedAtMs, progress.nowMs);
      speed.textContent = t('progress.speedEta', { speed: formatSpeed(rate), eta: formatEta(progress.totalBytes - progress.doneBytes, rate) });
      detail.textContent = progress.detail ?? '';
    },
    setRoute: (text) => {
      route.textContent = text;
    },
    complete: (text) => {
      element.classList.add('progress--done');
      fill.style.width = '100%';
      percent.textContent = '100%';
      speed.textContent = '';
      detail.textContent = text;
    },
  };
};
